import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import { DashboardContainer } from 'components';
import Body from './Body';
import API from 'services/api';
const Index = () => {
  const dispatch = useDispatch();
  const [selectCategory, setSelectCategory] = useState({ label: 'Tier 1', value: 'tier_1' });
  const [locationList, setLocationList] = useState([]);
  const [selectLocationGroup, setSelectLocationGroup] = useState({ label: 'All', value: 'All' });
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [inSync, setInSync] = useState(false);

  useEffect(() => {
    init();
    // loadLocationGroup();
  }, []);

  useEffect(() => {
    if (searchInput == '') {
      setTableData(originalData);
    } else {
      const filteredResults = originalData.filter((data) =>
        Object.values(data).join(', ').toLowerCase().includes(searchInput.toLowerCase())
      );
      setTableData(filteredResults);
    }
  }, [searchInput]);

  // const loadLocationGroup = async () => {
  //   dispatch(loadingStart());
  //   await API.fetchLocationGroup()
  //     .then((response) => {
  //       if (response) {
  //         const list = response.map((item) => ({
  //           label: item.location_group,
  //           value: item.location_group
  //         }));
  //         setLocationList(list);
  //       }
  //     })
  //     .finally(() => {
  //       dispatch(loadingStop());
  //     });
  // };

  const syncReport = () => {
    setInSync(true);
    toast
      .promise(
        async () => {
          await API.SyncAmplifonPatientReport();
          init();
        },
        {
          pending: 'Report sync is in progress',
          success: 'Data is up to date now',
          error: 'Failed to sync report'
        }
      )
      .then(() => setInSync(false));
  };

  const init = async () => {
    dispatch(loadingStart());
    await API.fetchOngoingContestRecords()
      .then((response) => {
        if (response) {
          setTableData(response);
          setOriginalData(response);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  const addOngoingContestRecord = async () => {
    dispatch(loadingStart());
    await API.addContesAchievementRecord()
      .then(async (response) => {
        if (response) {
          await API.fetchOngoingContestRecords().then((response) => {
            if (response) {
              setTableData(response);
              setOriginalData(response);
            }
          });
          toast.success('Achievement Record Updated Successfully');
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };
  return (
    <DashboardContainer>
      <Body
        _this={{
          selectCategory,
          setSelectCategory,
          tableData,
          setTableData,
          selectLocationGroup,
          setSelectLocationGroup,
          locationList,
          searchInput,
          setSearchInput,
          syncReport,
          inSync,
          setInSync,
          addOngoingContestRecord
        }}
      />
    </DashboardContainer>
  );
};

export default Index;
